<div class="sidebar-backdrop" *ngIf="state.mobileOpen()" (click)="closeMobile()"></div>

<aside class="sidebar" [class.collapsed]="state.collapsed()" [class.mobile-open]="state.mobileOpen()">
  <div class="sidebar__logo">
    <i class="fas fa-shield-halved sidebar-brand-icon"></i>
    @if (!state.collapsed()) {
      <span class="logo-name">SecurPro</span>
    }
    <button class="toggle-btn" type="button" (click)="toggleCollapse()"
      [title]="state.collapsed() ? 'Expandir' : 'Recolher'">
      @if (state.collapsed()) {
        <hugeicons-icon [icon]="menuIcon" [size]="18"></hugeicons-icon>
      } @else {
        <hugeicons-icon [icon]="cancelIcon" [size]="18"></hugeicons-icon>
      }
    </button>
  </div>

  <nav class="sidebar__nav">
    <a routerLink="/admin/dashboards" routerLinkActive="active" class="nav-item"
      [pTooltip]="state.collapsed() ? 'Dashboard' : ''" tooltipPosition="right" (click)="closeMobile()">
      <hugeicons-icon [icon]="dashboardIcon" [size]="18"></hugeicons-icon>
      @if (!state.collapsed()) { <span>Dashboard</span> }
    </a>

    <div class="nav-group">
      <button type="button" class="nav-item nav-parent" (click)="toggleMenu('operacao')"
        [attr.aria-expanded]="isExpanded('operacao')" [pTooltip]="state.collapsed() ? 'Operação' : ''"
        tooltipPosition="right">
        <hugeicons-icon [icon]="briefcaseIcon" [size]="18"></hugeicons-icon>
        @if (!state.collapsed()) {
          <span>Operação</span>
          @if (isExpanded('operacao')) {
            <hugeicons-icon class="nav-chevron" [icon]="chevronDownIcon" [size]="12"></hugeicons-icon>
          } @else {
            <hugeicons-icon class="nav-chevron" [icon]="chevronRightIcon" [size]="12"></hugeicons-icon>
          }
        }
      </button>

      @if (isExpanded('operacao') && !state.collapsed()) {
        <div class="nav-children">
          <a routerLink="/admin/efetivos" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="userGroupIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Efectivos</span>
              <span class="nav-badge">{{ totalColaboradores }}</span>
            }
          </a>
          <a routerLink="/admin/postos" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="locationIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Postos</span>
              <span class="nav-badge">{{ totalPostos }}</span>
            }
          </a>
          <a routerLink="/admin/equipamentos" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="shieldIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Equipamentos</span>
              <span class="nav-badge">{{ totalEquipamentos }}</span>
            }
          </a>
          <a routerLink="/admin/financeiro" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="coinsIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Financeiro</span>
              <span class="nav-badge">{{ totalFaturas }}</span>
            }
          </a>
          <a routerLink="/admin/ocorrencias" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="informationCircleIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Ocorrências</span>
              <span class="nav-badge">{{ totalOcorrencias }}</span>
            }
          </a>
          <a routerLink="/admin/clientes" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="buildingIcon" [size]="18"></hugeicons-icon>
            @if (!state.collapsed()) {
              <span>Clientes</span>
              <span class="nav-badge">{{ totalClientes }}</span>
            }
          </a>
        </div>
      }
    </div>

    <div class="nav-group">
      <button type="button" class="nav-item nav-parent" (click)="toggleMenu('monitorizacao')"
        [attr.aria-expanded]="isExpanded('monitorizacao')" [pTooltip]="state.collapsed() ? 'Monitorização' : ''"
        tooltipPosition="right">
        <hugeicons-icon [icon]="computerIcon" [size]="18"></hugeicons-icon>
        @if (!state.collapsed()) {
          <span>Monitorização</span>
          @if (isExpanded('monitorizacao')) {
            <hugeicons-icon class="nav-chevron" [icon]="chevronDownIcon" [size]="12"></hugeicons-icon>
          } @else {
            <hugeicons-icon class="nav-chevron" [icon]="chevronRightIcon" [size]="12"></hugeicons-icon>
          }
        }
      </button>

      @if (isExpanded('monitorizacao') && !state.collapsed()) {
        <div class="nav-children">
          <a routerLink="/admin/posto-comando" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <i class="ri-radar-line"></i><span>Posto de Comando</span>
          </a>
          <a routerLink="/admin/relatorios" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="chart02Icon" [size]="18"></hugeicons-icon><span>Relatórios</span>
          </a>
        </div>
      }
    </div>

    <div class="nav-divider"></div>

    <div class="nav-group">
      <button type="button" class="nav-item nav-parent" (click)="toggleMenu('configuracoes')"
        [attr.aria-expanded]="isExpanded('configuracoes')" [pTooltip]="state.collapsed() ? 'Configurações' : ''"
        tooltipPosition="right">
        <hugeicons-icon [icon]="settingsIcon" [size]="18"></hugeicons-icon>

        @if (!state.collapsed()) {
          <span>Configurações</span>
          @if (isExpanded('configuracoes')) {
            <hugeicons-icon class="nav-chevron" [icon]="chevronDownIcon" [size]="12"></hugeicons-icon>
          } @else {
            <hugeicons-icon class="nav-chevron" [icon]="chevronRightIcon" [size]="12"></hugeicons-icon>
          }
        }
      </button>

      @if (isExpanded('configuracoes') && !state.collapsed()) {
        <div class="nav-children">

          <button type="button" class="nav-item nav-parent nav-parent--nested"
            (click)="toggleMenu('controlo-acesso')" [attr.aria-expanded]="isExpanded('controlo-acesso')">
            <hugeicons-icon [icon]="lockKeyholeIcon" [size]="18"></hugeicons-icon>
            <span>Controlo de Acesso</span>
            @if (isExpanded('controlo-acesso')) {
              <hugeicons-icon class="nav-chevron" [icon]="chevronDownIcon" [size]="12"></hugeicons-icon>
            } @else {
              <hugeicons-icon class="nav-chevron" [icon]="chevronRightIcon" [size]="12"></hugeicons-icon>
            }
          </button>

          @if (isExpanded('controlo-acesso')) {
            <div class="nav-children nav-children--nested">
              <a routerLink="/admin/utilizadores" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
                <hugeicons-icon [icon]="userMultipleIcon" [size]="18"></hugeicons-icon>
                <span>Utilizadores</span>
              </a>

              <a routerLink="/admin/permissoes" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
                <hugeicons-icon [icon]="securityCheckIcon" [size]="18"></hugeicons-icon>
                <span>Permissões</span>
              </a>

              <a routerLink="/admin/registos" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
                <hugeicons-icon [icon]="historyIcon" [size]="18"></hugeicons-icon>
                <span>Registos</span>
              </a>
            </div>
          }

          <a routerLink="/admin/configuracoes" routerLinkActive="active" class="nav-item" (click)="closeMobile()">
            <hugeicons-icon [icon]="slidersIcon" [size]="18"></hugeicons-icon>
            <span>Aplicação</span>
          </a>

        </div>
      }
    </div>
  </nav>

  <div class="sidebar__footer">
    @if (!state.collapsed()) {
      <div class="user-info">
        <div class="user-avatar">{{ userInitials }}</div>
        <div class="user-text">
          <strong>{{ userName }}</strong>
          <small>{{ userRole }}</small>
        </div>
      </div>
    } @else {
      <div class="user-avatar" style="margin: 0 auto" [pTooltip]="userName" tooltipPosition="right">
        {{ userInitials }}
      </div>
    }
  </div>
</aside>